export class ACCVEHTYPES {
    public MAPID!: number;
    public ACC_CODE!: string;
    public VEH_TYPE!: string;
}